export const SERVER_URL = 'https://freepin.teamalafia.com';
// export const SERVER_URL = 'http://192.168.2.45:8292';